import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const categoryLinks = [
  { label: "泰国腐剧", to: "/category/泰国腐剧" },
  { label: "双男主影视", to: "/tags/双男主" },
  { label: "最新更新", to: "/category/最新更新" },
  { label: "热门推荐", to: "/category/热门推荐" },
];

const mainLinks = [
  { label: "首页", to: "/", end: true },
  { label: "资讯", to: "/news", end: false },
  { label: "关于我们", to: "/about", end: false },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "px-3 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap",
      isActive
        ? "text-primary-600 bg-primary-50"
        : "text-foreground-700 hover:text-primary-600 hover:bg-background-100",
    ].join(" ");

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-heart-3-fill text-lg text-background-50"></i>
            </span>
            <span className="font-heading text-lg font-extrabold text-foreground-950 whitespace-nowrap">
              泰剧腐剧<span className="text-primary-500">双男主</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            <NavLink to="/" end className={linkClass}>
              首页
            </NavLink>
            <div
              className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <button
                type="button"
                className="flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                分类
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? "rotate-180" : ""}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute left-0 top-full pt-2">
                  <div className="w-52 rounded-lg border border-background-200 bg-background-50 p-2">
                    {categoryLinks.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer"
                      >
                        {item.label}
                        <i className="ri-arrow-right-s-line text-foreground-300"></i>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {mainLinks.slice(1).map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <Link
              to="/search"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line"></i>
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            aria-label="菜单"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-1">
            <NavLink to="/" end className={linkClass}>
              首页
            </NavLink>
            <p className="px-3 pb-1 pt-2 text-xs font-semibold text-foreground-400">分类</p>
            {categoryLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
            <div className="my-1 h-px bg-background-200"></div>
            <NavLink to="/news" className={linkClass}>
              资讯
            </NavLink>
            <NavLink to="/search" className={linkClass}>
              搜索
            </NavLink>
            <NavLink to="/about" className={linkClass}>
              关于我们
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}